import axios from "axios";
import serverMessage from "../server-message";

// The bundle dropdown every company/approval surface is built from. Its middleware alerts
// action.payload, so a rejection here is read out to the admin: reject through the shared
// helper, like the four writes do, and the server's reason survives. `error.message` on its
// own is axios's "Request failed with status code 500", which is never the reason.
export default function getBundleOptions() {
  return new Promise((resolve, reject) => axios
    .get(`/account/system-admin/api/v1/bundle-options`)
    .then((response) => resolve(response.data))
    .catch((error) => reject(serverMessage(error))));
}
